import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import quoteBaseImage from "../../assets/textdecor.png";
import paymentBaseImage from "../../assets/payment-image.png";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { useLocation } from "react-router-dom";
import "./Donate.css";

const Donate = ({ text = "Default donation text.", image = paymentBaseImage }) => {
  const navigate = useNavigate();
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const [selectedAmount, setSelectedAmount] = useState("");
  const [showPopup, setShowPopup] = useState(false); 

  const location = useLocation(); // Get the current route

  // useEffect(() => {
  //   const hasVisited = sessionStorage.getItem("hasVisited");
  
  //   if (!hasVisited && location.pathname === "/") {
  //     setTimeout(() => {
  //       setShowPopup(true);
  //       sessionStorage.setItem("hasVisited", "true"); // Set flag for current session
  //     }, 2000);
  //   } else {
  //     setShowPopup(false);
  //   }
  // }, [location.pathname]);
  

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleAmountChange = (e) => {
    setSelectedAmount(e.target.value);
  };

  const handleCustomAmountChange = (e) => {
    setSelectedAmount(e.target.value);
    document.querySelectorAll('input[name="donation-amount"]').forEach((radio) => {
      radio.checked = false;
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const name = document.getElementById("donation-name").value;
    const email = document.getElementById("donation-email").value;
    const phone = document.getElementById("donation-phone").value;
    const pan = document.getElementById("donation-pan").value;
    const donationType = document.getElementById("donation-type").value;
    const amount = selectedAmount;

    if (!name || !email || !phone || !amount || !pan) {
      setSnackbar({
        open: true,
        message: "Please fill in all the required fields.",
        severity: "warning",
      });
      return;
    }

    navigate("/donate-form", {
      state: {
        name,
        email,
        phone,
        amount,
        panAadhaar: pan,
        donationType,
      },
    });
  };

  return (
    <div>
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-container">
            <span className="popup-close" onClick={handleClosePopup}>&times;</span>
            <h2>Donate Now</h2>
            <p>Your contribution can make a difference!</p>

            <form className="donation-form-group" onSubmit={handleSubmit}>
              <label htmlFor="donation-type">Choose a donation type</label>
              <select id="donation-type" name="donation-type">
                <option value="general">Select</option>
                <option value="education">Cost of Education</option>
                <option value="food">Cost of Food</option>
                <option value="health">Cost of Medical</option>
                <option value="water">Cost of Water</option>
              </select>

              <input type="text" id="donation-name" placeholder="Name" className="custom-amount" />
              <input type="email" id="donation-email" placeholder="Email" className="custom-amount" />
              <input type="text" id="donation-phone" placeholder="Phone" className="custom-amount" />
              <input type="text" id="donation-pan" placeholder="PAN" className="custom-amount" />

              <label>Choose a donation amount</label>
              <div className="donation-options">
                <div>
                  <input type="radio" id="amount-1" name="donation-amount" value="1000" onChange={handleAmountChange} />
                  <label htmlFor="amount-1">Rs.1,000</label>
                </div>
                <div>
                  <input type="radio" id="amount-2" name="donation-amount" value="2000" onChange={handleAmountChange} />
                  <label htmlFor="amount-2">Rs.2,000</label>
                </div>
                <div>
                  <input type="radio" id="amount-3" name="donation-amount" value="3000" onChange={handleAmountChange} />
                  <label htmlFor="amount-3">Rs.3,000</label>
                </div>
                <div>
                  <input type="number" id="custom-amount" placeholder="Enter Custom Amount" className="custom-amount" onChange={handleCustomAmountChange} />
                </div>
              </div>

              <button type="submit" className="payment upi"><b>Proceed</b></button>
            </form>
          </div>
        </div>
      )}

      <Snackbar open={snackbar.open} autoHideDuration={6000} onClose={handleSnackbarClose}>
        <MuiAlert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: "100%" }}>
          {snackbar.message}
        </MuiAlert>
      </Snackbar>
    </div>
  );
};

export default Donate;
